const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "2013",
    title: "SSC-Secondary School Certificate",
    desc: "Bisur High-School Bisur",
    rate: "",
  },
  {
    id: 2,
    category: "education",
    year: "2013-2015",
    title: "HSC-Higher Secondary School Certificate",
    desc: "Sangli High-School and Jr.collage Sangli",
    rate: "",
  },
  {
    id: 3,
    category: "education",
    year: "2015-2018",
    title: "Bachelor of Science",
    desc: "Willingdone college of Arts and Science Vishrambagh,Sangli",
    rate: "",
  },
  {
    id: 4,
    category: "experience",
    year: "2022",
    title: "Full Stack Web-Development",
    desc: "Masai School, Bengalore",
    rate: "",
  },
  {
    id: 5,
    category: "experience",
    year: "2019",
    title: "DNA institute of communication and soft skill development ,vishrambagh",
    desc: "Here i have learned some soft skill with some communication techniques and english fluency.I have also worked as an assistant of Dr.Sandeep Patil",
    rate: " ",
  },
  // {
  //   id: 6,
  //   category: "experience",
  //   year: "During 20",
  //   title: "Diploma in Computer Science",
  //   desc: "Maecenas finibus nec sem ut imperdiet. Ut tincidunt est ac dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet sem in, lobortis mauris hendrerit ante.",
  //   rate: "5.00/5 ",
  // },
]

export default ResumeApi